import {ADD_ALERT, POP_ALERT, CLEAR_ALERTS} from 'actions/types';

var alertModalsInitialState = {
    alerts:[]
};
export default (state = alertModalsInitialState, action) => {
    switch(action.type) {
        case ADD_ALERT: 
            return {...state, alerts:state.alerts.concat([action.alert])};
        case POP_ALERT: 
            return {...state, alerts:state.alerts.filter((a,i) => i>0)};
        case CLEAR_ALERTS: 
            return {...state, alerts:[]};
        default:            
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/alertModals.js